import Vue from 'vue';
import Vuex, { Store } from 'vuex';
import { EnquiryStore } from '@/stores/enquiries/store';
import { QuoteStore } from '@/stores/quotes/store';
import { ApprovalStore } from '@/stores/approvals/store';
import { OrderStore } from '@/stores/orders/store';
import { EnvironmentStore } from '@/stores/environment/store';
import { UserStore } from '@/stores/user/store';
import { AccountApi } from '@/api/account-api';
import router from '@/router';
import { ReportsStore } from '@/stores/reports/store';
import { CustomerStore } from '@/stores/customers/store';
import { CostCentreStore } from '@/stores/costcentres/store';

Vue.use(Vuex);

const accountApi = new AccountApi();

export default new Store({
    modules: {
        enquiry: new EnquiryStore(),
        quote: new QuoteStore(),
        approval: new ApprovalStore(),
        order: new OrderStore(),
        environment: new EnvironmentStore(),
        user: new UserStore(),
        report: new ReportsStore(),
        customer: new CustomerStore(),
        costCentre: new CostCentreStore(),
    },
    state: {
        isLoading: true,
    },
    getters: {
        isLoading: (state) => state.isLoading,
    },
    mutations: {
        setLoading: (state, value: boolean) => {
            state.isLoading = value;
        },
    },
    actions: {
        logout: async (context) => {
            // TODO(Dan): Clean this up!
            context.commit('user/setUser', null);

            context.commit('quote/setAllQuotes', []);
            context.commit('quote/setAllQuotesPage', 1);
            context.commit('quote/setAllQuotesCurrentPageSize', 25);
            context.commit('quote/setAllQuotesTotalPages', 1);
            context.commit('quote/setAllQuotesTotal', 0);
            context.commit('quote/setAllQuotesFilterStatus', '');
            context.commit('quote/setAllQuotesFrom', null);
            context.commit('quote/setAllQuotesTo', null);

            context.commit('order/setOrders', []);
            context.commit('order/setPage', 1);
            context.commit('order/setCurrentPageSize', 25);
            context.commit('order/setTotalPages', 1);
            context.commit('order/setTotal', 0);
            context.commit('order/setFilterStatus', '');
            context.commit('order/setFrom', null);
            context.commit('order/setTo', null);

            context.commit('enquiry/setAllEnquiries', []);
            context.commit('enquiry/setAllEnquiriesPage', 1);
            context.commit('enquiry/setAllEnquiriesCurrentPageSize', 25);
            context.commit('enquiry/setAllEnquiriesTotalPages', 1);
            context.commit('enquiry/setAllEnquiriesTotal', 0);
            context.commit('enquiry/setAllEnquiriesFilterStatus', '');
            context.commit('enquiry/setAllEnquiriesFrom', null);
            context.commit('enquiry/setMyEnquiriesTo', null);
            context.commit('enquiry/setMyEnquiries', []);
            context.commit('enquiry/setMyEnquiriesPage', 1);
            context.commit('enquiry/setMyEnquiriesPageSize', 25);
            context.commit('enquiry/setMyEnquiriesTotalPages', 1);
            context.commit('enquiry/setMyEnquiriesTotal', 0);
            context.commit('enquiry/setMyEnquiriesFilterStatus', '');
            context.commit('enquiry/setMyEnquiriesFrom', null);
            context.commit('enquiry/setMyEnquiriesTo', null);

            context.commit('approval/setAllApprovals', []);
            context.commit('approval/setAllApprovalsPage', 1);
            context.commit('approval/setAllApprovalsCurrentPageSize', 25);
            context.commit('approval/setAllApprovalsTotalPages', 1);
            context.commit('approval/setAllApprovalsTotal', 0);
            context.commit('approval/setAllApprovalsFilterStatus', '');
            context.commit('approval/setAllApprovalsFrom', null);
            context.commit('approval/setAllApprovalsTo', null);

            context.commit('report/setAllReports', []);
            context.commit('report/setAllReportsPage', 1);
            context.commit('report/setAllReportsCurrentPageSize', 25);
            context.commit('report/setAllReportsTotalPages', 1);
            context.commit('report/setAllReportsTotal', 0);
            context.commit('report/setAllReportsFilterStatus', '');
            context.commit('report/setAllReportsFrom', null);
            context.commit('report/setAllReportsTo', null);

            await accountApi.logoutAsync();

            await router.push({ name: 'logout' });

            // Note(Seb): These need to be set here instead of before the actual logout because we would get a forbidden page in between these being "reset" and actually logging out
            // For that split second we are still technically logged in and resetting the customers and sites which are essential for permissions
            context.commit('customer/setCustomers', []);
            context.commit('user/setCurrentCustomer', null);
            context.commit('user/setCurrentSite', null);
        },
    },
});
